export default "__VITE_ASSET__DwY8xzqA__"